var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-nav',{attrs:{"changeView":_vm.changeView}}),_vm._v(" "),_c(_vm.view,{tag:"component",attrs:{"person":_vm.person,"client-id":_vm.clientId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }